import { Controller } from "stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    console.log("connected")
  }

  copy() {
    const text = this.buttonTarget.dataset.textToCopy
    navigator.clipboard.writeText(text)
      .then(() => {
        alert("Copiado para a área de transferência!")
      })
      .catch((error) => {
        console.error("Erro ao copiar:", error)
      })
  }
}
